/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, array, bool, string, node,
} from 'prop-types';
import ServiceLabel from './ServiceLabel';

const CalendarModalBottomDiv = ({
    brandId,
    classes,
    serviceLevels,
    deliveryImage,
    isDesktop,
    shippingMessage,
}) => (
    <div className={classes.mobBottomDiv}>
        <div className={`${classes.mobBottomLeft} mobBottomLeft ${isDesktop ? 'mobBottomLeftV2' : ''}`}>
            {shippingMessage}
            <ServiceLabel serviceLevels={serviceLevels} isDesktop={isDesktop} />
        </div>
    </div>
);

CalendarModalBottomDiv.propTypes = {
    classes: object.isRequired,
    serviceLevels: array.isRequired,
    deliveryImage: string.isRequired,
    isDesktop: bool,
    shippingMessage: node.isRequired,
    brandId: string.isRequired,
};

CalendarModalBottomDiv.defaultProps = {
    isDesktop: false,
};

export default CalendarModalBottomDiv;
